import { PATHWAY } from "@/constants/testIds";
import { DISCLAIMER_LINES, STAKEHOLDER_DISCLAIMER } from "@/lib/pathwayData";

export default function DisclaimerBanner() {
  return (
    <div
      data-testid={PATHWAY.disclaimerBanner}
      className="border-y hairline bg-[#121212]"
    >
      <div className="mx-auto max-w-7xl px-6 py-5 md:px-12">
        <div className="grid gap-4 md:grid-cols-[220px_1fr] md:gap-10">
          <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#dc2626]">
            Synthetic playground
          </div>
          <div>
            <ul className="space-y-1.5 text-[13px] leading-relaxed text-neutral-400">
              {DISCLAIMER_LINES.map((d) => (
                <li key={d}>{d}</li>
              ))}
            </ul>
            <p className="mt-4 border-t hairline pt-3 text-[12px] italic leading-relaxed text-neutral-500">
              {STAKEHOLDER_DISCLAIMER}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
